import { useEffect, useState } from 'react'
import './Sections.scss'
import { emptyFunc } from '../../../types/constants'
import { IFormFieldOption } from '../FormBuilder/FormBuilder'

interface IRadioInputProps {
  name: string
  title: string
  className?: string
  defaultValue?: string
  fields: IFormFieldOption[]
  hidden?: boolean // Section is hidden
  disabled: boolean
  handleChange: (name: string, value: string, valid: boolean) => void
}

export const RadioSection = (props: IRadioInputProps) => {
  const [selectedValue, setSelectedValue] = useState<string>('')

  useEffect(() => {
    if (props.defaultValue) {
      props.handleChange(props.name, props.defaultValue, true)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    
    if (props.hidden || props.fields.find(f => !f.hidden && f.value === selectedValue)) {
      
      setSelectedValue('')
      props.handleChange(props.name, selectedValue, true)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.hidden, props.fields])

  useEffect(() => {
    props.handleChange(props.name, selectedValue, true)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue])

  const valueChanged = (value: string) => {
    if (props.disabled) {
      return
    }

    setSelectedValue(selectedValue === value ? '' : value)
  }

  return (
    <div className={'fade disabled ' + (!props.hidden ? 'in' : 'out')}>
      <div className="box-title center">
          {props.title}
      </div>
      <div className={'control-group ' + (props.className ?? '')}>
        {props.fields.map((field, i) => !field.hidden && (
          <label className={('control control-radio ' + (selectedValue === field.value ? 'selected' : ''))} key={i}>
            <input 
              type="radio" 
              value={field.value} 
              name={props.name} 
              onChange={() => emptyFunc} 
              onClick={() => valueChanged(field.value!)} 
              checked={selectedValue === field.value}
            />
            <div className="control_indicator"></div>
            <div className='checkLabel'>
              <i className={field.icon} />
              {field.label}
            </div>
          </label>
        ))}
      </div>
    </div>
  )
}